module.exports = __webpack_public_path__ + "static/media/A_iko_2_czcionka_active.0fc02344.svg";